import { useState } from 'react';
import type { ReactElement } from 'react';

import { Component as PlusIcon } from 'icons/icon-ui--plus.svg';
import AddressModal from 'components/shared/modals/AddressModal';
import Address from '../../../models/Address';
import { NotificationType } from '../../../models/Notifications';
import type { INotification } from '../../../models/Notifications';

import useNotifications from '../../../hooks/useNotifications';
import { getQueryParam } from '../../../utils/location';

type Props = {
    isHidden: boolean;
    onAdd: (address: Address) => void;
};

function AddAddressValue({ isHidden, onAdd }: Props): ReactElement {
  const { dispatch } = useNotifications();
  const [showAddressModal, setShowAddressModal] = useState(
    getQueryParam('add') === 'address',
  );

  const handleCloseAddressModal = (address) => {
    if (address) {
      onAdd(address);
      dispatch({
        type: 'addNotification',
        notification: {
          id: address.id,
          notification_type: NotificationType.ADDRESS_CHANGE,
          operation: 'ADD',
        } as INotification,
      });
    }
    setShowAddressModal(false);
  };

  if (isHidden) return <></>;

  return (
    <>
      <div className="c-my-account__address__address__item">
        {showAddressModal && (
          <AddressModal
            isPrimaryEditable
            isAccountManagementPage
            onClose={handleCloseAddressModal}
          />
        )}
      </div>

      <div className="c-my-account__address__address__item">
        <button
          type="button"
          className="c-my-account__address__add-address-link"
          onClick={() => setShowAddressModal(true)}
        >
          <div className="c-my-account__address__add-address-link__content">
            <PlusIcon height="21" width="21" />
            <span className="d-block">Add Address</span>
          </div>
        </button>
      </div>
    </>
  );
}

export default AddAddressValue;
